import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_2 = { class: "selection-row" }
const _hoisted_3 = { class: "upload-container" }
const _hoisted_4 = { class: "el-upload__tip" }
const _hoisted_5 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_6 = { class: "sender-fields" }
const _hoisted_7 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_8 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_9 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_10 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_11 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_12 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_13 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_14 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_15 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_16 = {
  key: 0,
  class: "el-form-item__error"
}
const _hoisted_17 = {
  key: 0,
  class: "form-actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, { "label-position": "top" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "Тип отправителя",
        class: _normalizeClass({ 'is-error': _ctx.showErrors && !_ctx.senderType })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: _ctx.senderType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.senderType) = $event)),
            placeholder: "Выберите тип отправителя"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.senderTypeLabels, (label, value) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: value,
                  label: label,
                  value: value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_ctx.showErrors && !_ctx.senderType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Пожалуйста, выберите тип отправителя"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.sendersList.length > 0 && !_ctx.isStandalone)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "Использовать отправителя из прошлых заказов",
              class: "selection-item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.selectedSenderComputed,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedSenderComputed) = $event)),
                  placeholder: "Выберите отправителя"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_el_option, {
                      key: 'new',
                      label: "Новый отправитель",
                      value: null
                    })),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sendersList, (sender) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: sender.id,
                        label: sender.name,
                        value: sender
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, { class: "selection-item" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_upload, {
                action: "",
                "auto-upload": false,
                "on-change": _ctx.handleFileChange,
                "before-upload": _ctx.beforeUpload,
                limit: 1,
                "file-list": _ctx.fileList,
                "on-remove": _ctx.handleRemoveFile,
                ref: "uploadRef"
              }, {
                tip: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, "Загрузите карточку " + _toDisplayString(_ctx.senderTypeLabelsGentiveCase[_ctx.senderType as SenderTypeEnum]) + " - наш сервис автоматически заполнит все поля", 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, { type: "primary" }, {
                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                      _createTextVNode("Загрузить карточку")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["on-change", "before-upload", "file-list", "on-remove"]),
              (_ctx.isProcessingFile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_el_icon, { class: "loading-icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Loading)
                      ]),
                      _: 1
                    }),
                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "loading-text" }, "Файл обрабатывается", -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_form_item, {
          label: "Наименование",
          class: _normalizeClass({ 'is-error': _ctx.showErrors && !_ctx.name })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event))
            }, null, 8, ["modelValue"]),
            (_ctx.showErrors && !_ctx.name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Это поле обязательное"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_form_item, { label: "Наименование (англ.)" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.nameEn,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.nameEn) = $event))
            }, null, 8, ["modelValue"]),
            (_ctx.showErrors && !_ctx.nameEn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Это поле обязательное"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "ИНН",
          class: _normalizeClass({ 'is-error': _ctx.showErrors && !_ctx.inn })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.inn,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inn) = $event))
            }, null, 8, ["modelValue"]),
            (_ctx.showErrors && !_ctx.inn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Это поле обязательное"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_form_item, {
          label: "Наименование банка",
          class: _normalizeClass({ 'is-error': _ctx.showErrors && !_ctx.bankName })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.bankName,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bankName) = $event))
            }, null, 8, ["modelValue"]),
            (_ctx.showErrors && !_ctx.bankName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Это поле обязательное"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_form_item, { label: "Наименование банка (англ.)" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.bankNameEn,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bankNameEn) = $event))
            }, null, 8, ["modelValue"]),
            (_ctx.showErrors && !_ctx.bankNameEn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Это поле обязательное"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "БИК",
          class: _normalizeClass({ 'is-error': _ctx.showErrors && !_ctx.bankBik })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.bankBik,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.bankBik) = $event))
            }, null, 8, ["modelValue"]),
            (_ctx.showErrors && !_ctx.bankBik)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Это поле обязательное"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_form_item, {
          label: "Расчетный счет",
          class: _normalizeClass({ 'is-error': _ctx.showErrors && !_ctx.bankCurrentAccount })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.bankCurrentAccount,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.bankCurrentAccount) = $event))
            }, null, 8, ["modelValue"]),
            (_ctx.showErrors && !_ctx.bankCurrentAccount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Это поле обязательное"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_form_item, { label: "Корреспондентский счет" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.bankCorrespondentAccount,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.bankCorrespondentAccount) = $event))
            }, null, 8, ["modelValue"]),
            (_ctx.showErrors && !_ctx.bankCorrespondentAccount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Это поле обязательное"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "Юридический адрес" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.entityAddress,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.entityAddress) = $event))
            }, null, 8, ["modelValue"]),
            (_ctx.showErrors && !_ctx.entityAddress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Это поле обязательное"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "Юридический адрес (англ.)" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.entityAddressEn,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.entityAddressEn) = $event))
            }, null, 8, ["modelValue"]),
            (_ctx.showErrors && !_ctx.entityAddressEn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Это поле обязательное"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.senderType === _ctx.SenderTypeEnum.IP)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "ОГРНИП"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.ogrnip,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.ogrnip) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.senderType === _ctx.SenderTypeEnum.OOO)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_el_form_item, { label: "КПП" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.kpp,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.kpp) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Имя генерального директора" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.ceoName,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.ceoName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.senderType === _ctx.SenderTypeEnum.SELF_EMPLOYED)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(_component_el_form_item, { label: "Юридический адрес" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.legalAddress,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.legalAddress) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Юридический адрес (англ.)" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.legalAddressEn,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.legalAddressEn) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Адрес банка" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.bankAddress,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.bankAddress) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Адрес банка (англ.)" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.bankAddressEn,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.bankAddressEn) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Email" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.email,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.email) = $event)),
                    type: "email"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Телефон" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.phone,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.phone) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isStandalone)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_component_el_button, {
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$emit('cancel')))
            }, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [
                _createTextVNode("Отмена")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.handleSave,
              loading: _ctx.loading
            }, {
              default: _withCtx(() => _cache[25] || (_cache[25] = [
                _createTextVNode("Сохранить")
              ])),
              _: 1
            }, 8, ["onClick", "loading"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}